<div class="table">
  <button class="section-btn" (click)="openAddDialog()">
    <img src="../../../../assets/icons/add.svg" alt="" />
    Adauga
  </button>
  <table
    datatable
    [dtOptions]="dtOptions"
    [dtTrigger]="dtTrigger"
    class="row-border hover"
  ></table>
  <!-- <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div> -->
</div>
